module.exports = __webpack_public_path__ + "static/media/marketing-enterprise.47fc57e6.svg";